import React, { useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { app } from '../firebase';

const maskPhone = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '—';
  const visible = raw.slice(0, 5);
  return raw.length > 5 ? `${visible}******` : raw;
};

function MaskedPhone({ phoneNumber, studentId, studentName, className = '' }) {
  const [revealed, setRevealed] = useState(false);
  const auth = getAuth();
  const db = getFirestore(app);

  const handleReveal = async (event) => {
    event.preventDefault();
    if (revealed) return;
    setRevealed(true);

    try {
      const user = auth.currentUser;
      const adminName = user?.displayName || user?.email || 'Admin';
      const adminId = user?.uid || 'unknown';
      const studentLabel = studentName || 'student';
      const studentKey = studentId ? ` (${studentId})` : '';

      await addDoc(collection(db, 'AdminActivity'), {
        adminId,
        adminName,
        action: 'Viewed student phone number',
        details: `Viewed phone for ${studentLabel}${studentKey}`,
        studentId: studentId || null,
        studentName: studentName || null,
        createdAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Failed to log phone view:', error);
    }
  };

  if (!phoneNumber) {
    return <span className={`maskedPhone ${className}`}>—</span>;
  }

  return (
    <span className={`maskedPhone ${className}`}>
      {revealed ? (
        <a href={`tel:${phoneNumber}`} className="maskedPhoneValue">
          {phoneNumber}
        </a>
      ) : (
        <span className="maskedPhoneValue">{maskPhone(phoneNumber)}</span>
      )}
      {!revealed && (
        <button type="button" className="maskedPhoneLink" onClick={handleReveal}>
          View
        </button>
      )}
    </span>
  );
}

export default MaskedPhone;
